import { classicActionRequest, classicOperation } from './classic-admin-api';
export type LiveopsFeature = 'coupons' | 'mail' | 'news' | 'leaderboards';
export function liveopsRead<T>(feature: LiveopsFeature, action: string, args: Record<string, unknown> = {}, signal?: AbortSignal) {
    return classicActionRequest<T>(`/liveops/${feature}/${action}?${new URLSearchParams({ args: JSON.stringify(args) })}`, signal);
}
export const liveopsOperation = (feature: LiveopsFeature, action: string, args: Record<string, unknown>) => classicOperation(`/liveops/${feature}/${action}`, args);
